// import styled from "styled-components";

const SingleProduct = () => {
  return (
    <>
      <h1>single page </h1>
    </>
  );
};

export default SingleProduct;
